import { Link, useLocation, useNavigate } from "react-router-dom";
import { Dropdown, Typography, Avatar, Menu as AntdMenu } from "antd";
import { DownOutlined, LogoutOutlined, SettingOutlined } from "@ant-design/icons";
import { NavbarContainer, Menu, ProfileButton, NameContainer } from "./elements";
import { PageHeader } from "@ant-design/pro-components";
import { useUser } from "../../providers/user";
import { nanoid } from "nanoid";

const { Text } = Typography;

function NavBar() {
  const { user, logout } = useUser();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    logout();
  };

  const pageTitles: Record<string, string> = {
    "/": "Inicio",
    "/dashboard": "Home",
    "/settings": "Configuración",
    "/profile": "Perfil",
    "/login": "Iniciar Sesión",
    "/orders": "Ordenes Activas",
    "/abandoned-checkout": "Carritos Abandonados",
    "/history": "Historial de Órdenes",
    "/products": "Productos",
    "/categories": "Categorías",
    "/banners": "Banners",
    "/coupons": "Cupones",
    "/franchise": "Franquicias",
    "/notifications": "Notificaciones",
    "/users": "Usuarios",
    "/clients": "Clientes",
    "/zones": "Zonas",
    "/tickets": "Tickets",
    "/invoices": "Facturas",
    // Agrega más rutas según sea necesario
  };

  const format = (pathname: string) => {
    // Busca el título en el diccionario, si no existe, formatea el pathname
    return pageTitles[pathname] || (
      pathname.substring(pathname.lastIndexOf("/") + 1)
        .replace(/-/g, " ")
        .replace(/\b\w/g, l => l.toUpperCase())
    );
  };

  return (
    <NavbarContainer>
      <Menu mode="horizontal" style={{ display: "flex",
        justifyContent: "flex-end" }}>
        <PageHeader style={{ marginRight: "auto",
          padding: "0px 20px" }} title={format(pathname)} />
        <Dropdown
          trigger={["click"]}
          overlay={
            <AntdMenu mode="vertical">
              <AntdMenu.ItemGroup title="Cuenta">
                <AntdMenu.Item
                  key={nanoid()}
                  onClick={() => navigate("/settings")}
                  icon={<SettingOutlined />}
                >
                  Configuración
                </AntdMenu.Item>
              </AntdMenu.ItemGroup>
              <AntdMenu.ItemGroup title="Sesión">
                <AntdMenu.Item
                  key={nanoid()}
                  onClick={() => handleLogout()}
                  icon={<LogoutOutlined style={{ color: "red" }} />}
                >
                  <Link to="/login" style={{ color: "red" }}>
                    Salir
                  </Link>
                </AntdMenu.Item>
              </AntdMenu.ItemGroup>
            </AntdMenu>
          }
        >
          <ProfileButton type="text">
            <Avatar style={{ marginRight: 15 }} size={35} src={user?.img}>
              {user?.firstName?.[0]}
            </Avatar>
            <NameContainer>
              <Text style={{ fontSize: 12,
                color: "#4B89E3" }} type="secondary">
                Hola,
              </Text>
              <Text style={{ marginTop: -5,
                color: "#4B89E3" }} strong>
                {user?.email}
              </Text>
            </NameContainer>
            <DownOutlined />
          </ProfileButton>
        </Dropdown>
      </Menu>
    </NavbarContainer>
  );
}

export default NavBar;
